var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsIP, IsObject, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
export class PreventionCourseApprovalFullSizeDto {
    id;
    createdAt;
    updatedAt;
    ipAddress;
    user;
    userId;
    preventionCourse;
    preventionCourseId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseApprovalFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseApprovalFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseApprovalFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsIP(),
    Exclude(),
    __metadata("design:type", String)
], PreventionCourseApprovalFullSizeDto.prototype, "ipAddress", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], PreventionCourseApprovalFullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseApprovalFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Function)
], PreventionCourseApprovalFullSizeDto.prototype, "preventionCourse", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseApprovalFullSizeDto.prototype, "preventionCourseId", void 0);
//# sourceMappingURL=prevention-course-approval.full-size.dto.js.map